import { Question } from "../EntityTypeSurvey/types";

/**
 * Compares two arrays of questions to determine if they are equal.
 * Treats empty, null, or undefined answers as "No" for comparison purposes.
 *
 * @param originalQuestions - The original array of questions
 * @param updatedQuestions - The updated array of questions to compare against
 * @returns true if questions are equal, false otherwise
 */
export const areQuestionsEqual = (
  originalQuestions: Question[],
  updatedQuestions: Question[],
): boolean => {
  return (
    originalQuestions.length === updatedQuestions.length &&
    originalQuestions.every((originalQ, index) => {
      const updatedQ = updatedQuestions[index];
      return (
        originalQ.id === updatedQ.id &&
        originalQ.question === updatedQ.question &&
        (originalQ.answer || "No") === (updatedQ.answer || "No")
      );
    })
  );
};
